import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Users } from "lucide-react";

export default function RsvpCard() {
  const [rsvps, setRsvps] = useState([]);

  useEffect(() => {
    api.get("/admin/rsvp-signups").then((r) => setRsvps(r.data || []));
  }, []);

  return (
    <div className="tac-card p-7 mt-8" data-testid="admin-rsvps-card">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="overline flex items-center gap-2">
            <Users size={12} /> Tour list
          </div>
          <h2 className="font-display text-3xl uppercase mt-2">RSVP signups</h2>
        </div>
        <div className="font-mono-tactical text-xs text-white/50 uppercase tracking-[0.25em]">
          {rsvps.length} fans
        </div>
      </div>
      <div className="mt-6 max-h-[420px] overflow-y-auto divide-y divide-white/5">
        {rsvps.length === 0 && (
          <div className="py-8 text-white/60 text-sm">No signups yet.</div>
        )}
        {rsvps.map((r) => (
          <div key={r.id} className="py-3 grid md:grid-cols-12 gap-3" data-testid={`rsvp-${r.id}`}>
            <div className="md:col-span-3 font-semibold">{r.name}</div>
            <div className="md:col-span-3 text-sm">
              <a href={`mailto:${r.email}`} className="text-[#FF1493] hover:underline">{r.email}</a>
            </div>
            <div className="md:col-span-3 text-sm text-white/80">{r.city}{r.state ? `, ${r.state}` : ""}</div>
            <div className="md:col-span-3 font-mono-tactical text-[10px] uppercase tracking-[0.2em] text-white/40">
              {new Date(r.created_at).toLocaleDateString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
